import { useLocation } from 'umi';
import { useIntl } from 'react-intl';
import { getSession } from '@/utils/common';
import { Select } from 'iglooform';
import * as constants from '../constants';
import * as SESSION_KEYS from '@/configs/session-storage-keys';

interface IUseVehicleOptions {
  (): React.ReactNode;
}

const useVehicleOptions: IUseVehicleOptions = () => {
  const location: any = useLocation();
  const { query } = location;
  let totalStep = Number(query.totalStep);
  const { formatMessage } = useIntl();
  const planPicked = getSession(SESSION_KEYS.PICKED_PLAN_INFO);
  const coverageType = planPicked?.coverageType;
  const soiCategory = planPicked?.soiCategory;

  const allVehicleTypes = constants.getVehicleTypes({ formatMessage });
  const allUsingPurpose = constants.getUsingPurpose({ formatMessage });
  const allOptions = constants.getAllOptions({ formatMessage });
  const vehicleTypes =
    totalStep === 3
      ? allOptions.filter((e) => e.groupBy === 'vehicle')
      : allUsingPurpose.filter((e) => e.groupBy === 'vehicle');
  const motorcycleTypes = allVehicleTypes.filter(
    (e) => e.groupBy === 'motorcycle',
  );
  const physicalDamageTypes = allVehicleTypes.filter((e) =>
    ['Passenger Transportation', 'Pick-up'].includes(e.name),
  );

  const carOptions = vehicleTypes.map((e) => (
    <Select.Option key={e.name} value={e.name}>
      {e.label}
    </Select.Option>
  ));

  const motorcycleOptions = motorcycleTypes.map((e) => (
    <Select.Option key={e.name} value={e.name}>
      {e.label}
    </Select.Option>
  ));

  const physicalDamageOptions = physicalDamageTypes.map((e) => (
    <Select.Option key={e.name} value={e.name}>
      {e.label}
    </Select.Option>
  ));

  const anyOptions = (
    <>
      <Select.OptGroup
        label={formatMessage({
          id: 'Vehicle Type',
        })}
      >
        {carOptions}
      </Select.OptGroup>
      <Select.OptGroup
        label={formatMessage({
          id: 'Motorcycle',
        })}
      >
        {motorcycleOptions}
      </Select.OptGroup>
    </>
  );

  if (totalStep === 3) {
    return anyOptions;
  }

  switch (coverageType) {
    case 'tpl':
      switch (soiCategory) {
        case 'car':
          return carOptions;
        case 'motorcycle':
          return motorcycleOptions;
        default:
          return anyOptions;
      }
    case 'cpd':
      return physicalDamageOptions;
    default:
      return anyOptions;
  }
};

export default useVehicleOptions;
